import { useStoreConfig } from '@/stores/config'

//vueファイル一覧を取得
const vueModules = require.context('@/views', true, /.*_*\.vue/,'lazy')
//componentファイル一覧を取得
const componentModules = require.context('@/components', true, /.*_*\.vue/,'lazy')
//ドメイン名
let domainName = ''
//サブドメイン名
let subDomainName = ''

//ドメイン名付けのvueファイルがある場合、それを取得する
export const getVueName = (fileName) => {
  const config = useStoreConfig();
  let Module = null
  if(!domainName){
    domainName = config.templateDomainName;
  }
  if(!subDomainName){
    subDomainName = config.subDomainName;
  }
  for(let item of vueModules.keys()){
    item = item.replace('./', '')
    if(domainName != '' && subDomainName != '' && item.toLowerCase() == fileName.replace('.vue','_' + domainName + '_' + subDomainName +'.vue').toLowerCase()){
      Module = item
    }
    if(subDomainName != '' && item.toLowerCase() == fileName.replace('.vue','_' + subDomainName +'.vue').toLowerCase()){
      Module = item
    }
    if(item.toLowerCase() == fileName.replace('.vue','_' + domainName +'.vue').toLowerCase()){
      Module = item
    }
  }

  if(Module != null){
    return Module
  }

  return fileName
}

//ドメイン名付けのcomponentファイルがある場合、それを取得する
export const getComponentName = (fileName) => {
  const config = useStoreConfig();
  let Module = null
  if(!domainName){
    domainName = config.templateDomainName;
  }
  if(!subDomainName){
    subDomainName = config.subDomainName;
  }
  for(let item of componentModules.keys()){
    item = item.replace('./', '')
    if(domainName != '' && subDomainName != '' && item.toLowerCase() == fileName.replace('.vue','_' + domainName + '_' + subDomainName +'.vue').toLowerCase()){
      Module = item
    }
    if(subDomainName != '' && item.toLowerCase() == fileName.replace('.vue','_' + subDomainName +'.vue').toLowerCase()){
      Module = item
    }
    if(item.toLowerCase() == fileName.replace('.vue','_' + domainName +'.vue').toLowerCase()){
      Module = item
    }
  }

  if(Module != null){
    return Module
  }

  return fileName
}

